import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "FEED_IMPORT_ERROR":
            return action.error;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "FEED_IMPORT_LOADING":
            return action.loading;

        default:
            return state;
    }
}

export function importing(state = null, action) {
    switch (action.type) {
        case "FEED_IMPORT_SUCCESS":
            return action.importing;

        default:
            return state;
    }
}

export default combineReducers({error, loading, importing});